import { FromProviderType } from '../interfaces/from-type-enum';

export function getCurrentProviderType(): FromProviderType | null {
  const currentProviderType = sessionStorage.getItem('provider_type');
  switch (currentProviderType) {
    case FromProviderType.IMPERIA:
      return FromProviderType.IMPERIA;
    case FromProviderType.SUITEEDGE:
      return FromProviderType.SUITEEDGE;
    default:
      return null;
  }
}
